import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { setAadhar, setBeneficiaryAbha, setBeneficiaryAuthType, setBeneficiaryData, setBeneficiaryGender, setBeneficiaryMobileNumber, setBeneficiaryRedgOption, setTsnID, updateChild } from '@store/actions/beneficiaryAction';
import './AbhaChildModal.css';
import { benef_const } from "@constants/beneficiaryConstant";
import AuthenticationOptionModal from "@pages/Beneficiary-block/CreateBeneficiary/AuthenticationOptionModal";
import BeneficiaryRedgeOptionModal from "@pages/Beneficiary-block/CreateBeneficiary/BeneficiaryRedgeOptionModal";
import VerificationModal from "@pages/Beneficiary-block/CreateBeneficiary/VerificationModal";
import Demographic from "@pages/Beneficiary-block/CreateBeneficiary/Demographic";
import BenefeciaryUnderMobNo from "@pages/Beneficiary-block/CreateBeneficiary/BenefeciaryUnderMobNo";
import OTPVerification from '@pages/Beneficiary-block/CreateBeneficiary/OTP/index'
import BeneficiaryExistsModal from "@pages/Beneficiary-block/CreateBeneficiary/BeneficiaryExistsModal";

interface useType {
    showModal: boolean;
    handleBack: () => void;
}

const AbhaChildModal = ({ showModal, handleBack }: useType) => {
    const dispatch = useDispatch();
    const [showRedgOptionBeneficiary, setShowRedgOptionBeneficiary] = useState(false);
    const [showAuthBeneficiary, setShowAuthBeneficiary] = useState(false);
    const [showVerificationBeneficiary, setShowVerificationBeneficiary] = useState(false);
    const [showBenefeciaryUnderMobNoModal, setShowBenefeciaryUnderMobNoModal] = useState(false)
    const [showOTP, setShowOTP] = useState(false);
    const [showDemographicModal, setShowDemographicModal] = useState(false);
    const [linkedBenefDetails, setLinkedBenefDetails] = useState<string>('');
    const [showExistsModal, setShowExistsModal] = useState(false);
    const beneficiary = useSelector((state: RootState) => state.beneficiary);
    const beneficiaryData = useSelector((state: RootState) => state.beneficiary?.beneficiaryData);
    const beneficiaryDataref = useRef(beneficiaryData);
    useEffect(() => {
        beneficiaryDataref.current = beneficiaryData;
    }, [beneficiaryData]);

    const handleMappedData = (beneficiaryData: any) => {
        const obj = {
            firstName: beneficiaryData?.[0]?.name,
            middleName: '',
            lastName: '',
            gender: beneficiaryData?.[0]?.gender,
            dob: beneficiaryData?.[0]?.dob,
            ABHANumber: beneficiaryData?.[0]?.abhaId,
            phrAddress: beneficiaryData?.[0]?.address,
            kycVerified: beneficiaryData?.[0]?.kycVerified,
        };
        dispatch(updateChild('regChildDetails', obj));
    };

    const openAbhaVerification = async () => {
        dispatch(setBeneficiaryRedgOption(''));
        dispatch(setBeneficiaryAuthType(''));
        dispatch(setBeneficiaryData([]));
        dispatch(setBeneficiaryAbha(''));
        dispatch(setTsnID(''));
        dispatch(setBeneficiaryMobileNumber(''));
        dispatch(setAadhar(''));
        setShowRedgOptionBeneficiary(true);
    };

    useEffect(() => {
        openAbhaVerification();
    }, [showModal])

    const closeBeneficiarRedgOptionModal = (option: string) => {
        if (showRedgOptionBeneficiary && option === 'back') {
            setShowRedgOptionBeneficiary(false);
            handleBack();
            return;
        }
        setShowRedgOptionBeneficiary(false);
        if (option === benef_const.verifyOptions.abha || option === benef_const.verifyOptions.aadhar) {
            setShowAuthBeneficiary(true);
        }
        else if (option === benef_const.verifyOptions.phoneNumber) {
            setShowVerificationBeneficiary(true);
        }
        else if (option === benef_const.verifyOptions.back) {
            setShowRedgOptionBeneficiary(false);
        }
    };

    const closeBeneficiarAuthModal = (authType: string) => {
        setShowAuthBeneficiary(false);
        if (authType === benef_const.verifyOptions.back) {
            setShowRedgOptionBeneficiary(true);
        }
        else if (authType !== '') {
            setShowVerificationBeneficiary(true);
        }
    };

    const closeBeneficiaryExistModal = async (type: string, abhaNumber?: string, mob?: string, abhaAddress?: string) => {
        setShowExistsModal(false);
        if (type === benef_const.verifyOptions.yes) {
            if (
                beneficiary.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber ||
                (beneficiary.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiary.beneficiaryAuthType === benef_const.verifyOptions.otp)
            ) {
                setShowOTP(true);
            } else if (
                (beneficiary.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiary.beneficiaryAuthType === benef_const.verifyOptions.demographics) ||
                beneficiary.beneficiaryRedgeOption === benef_const.verifyOptions.abha
            ) {
                if (abhaNumber) {
                    handleMappedData(beneficiaryDataref.current)
                }
            }
        } else if (type === benef_const.verifyOptions.back) {
            if (
                beneficiary.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber ||
                (beneficiary.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiary.beneficiaryAuthType === benef_const.verifyOptions.otp) ||
                (beneficiary.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiary.beneficiaryAuthType === benef_const.verifyOptions.demographics)
            ) {
                setShowVerificationBeneficiary(true);
            } else if (beneficiary.beneficiaryRedgeOption === benef_const.verifyOptions.abha) {
                setShowRedgOptionBeneficiary(true);
                setTimeout(() => {
                    dispatch(setBeneficiaryRedgOption(''));
                    dispatch(setBeneficiaryAuthType(''));
                }, 1000);
            }
        }
        else if (type === benef_const.verifyOptions.backToOtherMethod) {
            setShowRedgOptionBeneficiary(true);
            setTimeout(() => {
                dispatch(setBeneficiaryRedgOption(''));
                dispatch(setBeneficiaryAuthType(''));
            }, 1000);
        }
        else {
            setShowDemographicModal(false);
            setTimeout(() => {
                dispatch(setBeneficiaryGender(''));
                dispatch(setBeneficiaryRedgOption(''));
                dispatch(setBeneficiaryAuthType(''));
            }, 1000);
        }
    }

    const closeVerificationBeneficiary = (type: string) => {
        setShowVerificationBeneficiary(false);
        switch (type) {
            case benef_const.verifyOptions.submit:
                if (beneficiary?.beneficiaryAuthType === benef_const.verifyOptions.otp ||
                    beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber ||
                    beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.abha) {
                    setShowOTP(true);
                } else if (beneficiary?.beneficiaryAuthType === benef_const.verifyOptions.demographics) {
                    setShowDemographicModal(true);
                }
                break;
            case benef_const.verifyOptions.back:
                if (beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber) {
                    setShowRedgOptionBeneficiary(true);
                } else if ((beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar ||
                    beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.abha) &&
                    beneficiary?.beneficiaryAuthType !== '') {
                    setShowAuthBeneficiary(true);
                } else if (beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar ||
                    beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.abha) {
                    setShowAuthBeneficiary(true);
                }
                break;
            case benef_const.verifyOptions.showExistModal:
                setShowExistsModal(true);
                break;
            default:
                setTimeout(dispatchFunction, 1000);
                break;
        }
    };

    const closeDemographicModal = async (type: string, abhaNumber: any, mob?: any, abhaAddress?: any) => {
        setShowDemographicModal(false);
        switch (type) {
            case benef_const.verifyOptions.submit:
                if (abhaNumber) {
                    handleMappedData(beneficiaryDataref.current)
                }
                break;
            case benef_const.verifyOptions.back:
                setShowVerificationBeneficiary(true);
                break;
            case benef_const.verifyOptions.backToOtherMethod:
                setShowRedgOptionBeneficiary(true);
                setTimeout(() => {
                    backToOtherMethodDispatchFunction()
                }, 1000);
                break;
            case benef_const.verifyOptions.showExistModal:
                setShowExistsModal(true);
                break;
            default:
                setTimeout(dispatchFunction, 1000);
                break;
        }
    };

    const closeOTPModal = async (type: string, abhaNumber: any, mobileNumber?: any, abhaAddress?: any) => {
        setShowOTP(false);
        switch (type) {
            case benef_const.verifyOptions.close:
                setTimeout(dispatchFunction, 1000);
                break;
            case benef_const.verifyOptions.back:
                setShowVerificationBeneficiary(true);
                break;
            case benef_const.verifyOptions.submit:
                if (beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber) {
                    setShowBenefeciaryUnderMobNoModal(true);
                } else if (
                    beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar ||
                    beneficiary?.beneficiaryRedgeOption === benef_const.verifyOptions.abha
                ) {
                    handleMappedData(beneficiaryDataref.current)
                }
                break;
            case benef_const.verifyOptions.showExistModal:
                setShowExistsModal(true);
                break;
            case benef_const.verifyOptions.backToOtherMethod:
                setShowRedgOptionBeneficiary(true);
                setTimeout(() => {
                    backToOtherMethodDispatchFunction()
                }, 1000);
                break;
            default:
                break;
        }
    };

    const closeBenefeciaryUnderMobNoModal = async (type: string) => {
        setShowBenefeciaryUnderMobNoModal(false);
        switch (type) {
            case benef_const.verifyOptions.back:
                setShowVerificationBeneficiary(true);
                break;
            case benef_const.verifyOptions.submit:
                handleMappedData(beneficiaryData)
                break;
            default:
                setTimeout(dispatchFunction, 1000);
                break;
        }
    };

    const dispatchFunction = async () => {
        dispatch(setBeneficiaryGender(''));
        dispatch(setBeneficiaryRedgOption(''));
        dispatch(setBeneficiaryAuthType(''));
    }

    const backToOtherMethodDispatchFunction = async () => {
        dispatch(setBeneficiaryRedgOption(''));
        dispatch(setBeneficiaryAuthType(''));
    }

    return (
        <div className="verify_abha_grid_changes">
            <BeneficiaryRedgeOptionModal showModal={showRedgOptionBeneficiary} handleClose={closeBeneficiarRedgOptionModal} showTempRegistration={false} />
            <AuthenticationOptionModal showModal={showAuthBeneficiary} handleClose={closeBeneficiarAuthModal} />
            <VerificationModal showModal={showVerificationBeneficiary} handleClose={closeVerificationBeneficiary} setLinkedBenefDetails={setLinkedBenefDetails} />
            <OTPVerification showModal={showOTP} handleClose={closeOTPModal} setLinkedBenefDetails={setLinkedBenefDetails} />
            <Demographic showModal={showDemographicModal} handleClose={closeDemographicModal} setLinkedBenefDetails={setLinkedBenefDetails} />
            <BenefeciaryUnderMobNo showModal={showBenefeciaryUnderMobNoModal} handleClose={closeBenefeciaryUnderMobNoModal} />
            <BeneficiaryExistsModal showModal={showExistsModal} handleClose={closeBeneficiaryExistModal} linkedBenefDetails={linkedBenefDetails} setLinkedBenefDetails={setLinkedBenefDetails} />
        </div>
    )
}

export default AbhaChildModal;
